import { 
    Competition, 
    CompetitionAPI, 
    DesignerAPI, 
    Designer,
    API,
    Lang,
} from "@brg/api";
import { ProfileUtils } from 'core/auth';
import { useToasts, useIsMobile, ResizedImage } from "@brg/ui";
import { useHistory } from "react-router-dom";
import {FC, useState, useEffect, useMemo} from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { 
    JuryHeader, 
    JuryContent, 
    JuryCardsWrapper 
} from "./styles";
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { CompetitionJuryCard } from "../CreateCompetitionPage/CompetitionJury/CompetitionJuryCard";
import { CompetitionJuryCardText } from "../CreateCompetitionPage/styles";
import { CreateLinkTo } from "shared/constants/linkTo";
import { SmthTitle, TitleText } from "shared/pages/opencallsPage/GetCompetitionItem/style";
import { Outer } from "shared/pages/explore/styles";
import nameUtils from "core/helpers/nameUtils";
import { AppTester } from "supporting";
import { LoaderSpinner } from "shared/modals/artzLegalsModal/LoaderAnimation";

interface IJuryProps {
    classname?: any;
    openLikeTab?: boolean;
    externalId?: string;
}

export const CompetitionJuryPage: FC <IJuryProps> = ({ openLikeTab, externalId }) => {

    /**
     * Парсер для отображение спецсимволов html 
     */
    const parser = new DOMParser();
    const decodedString = (str: string | undefined) => {
        return parser.parseFromString(`<!doctype html><body>${str}`, 'text/html').body.textContent;
    }

    const { id = externalId } = useParams<{ id: string }>();

    const history = useHistory();
    const isCGRave = AppTester.isCGRAVE();
    const { i18n: { language } } = useTranslation();
    const isMobile = useIsMobile();
    const [competition, setCompetition] = useState<Competition<'Local'>>();
    const [descriptionText, setDescriptionText] = useState<string>();
    const [juryList, setJuryList] = useState<Designer<'Global'>[]>([]);
    const translatedJuryList = useMemo(() => API.toLang<Designer<'Local'>[]>(juryList, language), [juryList, language])

    const [selectedTab, setSelectedTab] = useState('jury');
    const [visiblePopUp, setIsVisiblePopUp] = useState<boolean>(false);

    useEffect(() => {
        if (id) {
            CompetitionAPI.Get({ idCompetition: id})
            .then((r: any) => r.json())
            .then((v: any) => API.toLang<Competition<'Local'>>(v, language))
            .then((d: any) => setCompetition(d))
        }
    }, [id])

    const handleOpenProfileClick = (id: string) => {
        return history.push(CreateLinkTo.designer(id))
    }
    useEffect(() => {
        if (competition && competition?.juryID) {
            DesignerAPI.GetList({ designerIds: competition?.juryID || [] })
              .then((v: any) => v.json())
              //@ts-ignore
              .then((v) => setJuryList(v.data));

        }
        if (competition && competition?.competitionInfo?.juryText) {
            setDescriptionText(Lang(competition?.competitionInfo?.juryText, language));
        }
    }, [competition])

    if (openLikeTab) {
        return (
            <JuryCardsWrapper pt={"0"} isMobile={isMobile}>
                {!!translatedJuryList.length && translatedJuryList.map((jury: any) => (
                    <CompetitionJuryCard 
                        key={jury?.designerId}
                        avatar={ProfileUtils.getAvatarURLOrUndefined(jury)}
                        //@ts-ignore
                        fullName={nameUtils.getFullNameString(jury)}
                        text={Lang(jury?.about, language) || ''}
                        id={jury?.designerId}
                        onClick={handleOpenProfileClick}
                        hasContext={!!jury?.context}
                    />
                )) 
                }
            </JuryCardsWrapper>
        )
    }
    if(isCGRave){
        return (
            <Outer style={{ marginBottom: '64px' }}>
            {!translatedJuryList.length ? <LoaderSpinner color={'#909090'}/> 
            : <JuryCardsWrapper pt={"24"} isMobile={isMobile}>
                {translatedJuryList.length && translatedJuryList.map((jury: any) => (
                    <CompetitionJuryCard 
                        key={jury?.designerId}
                        avatar={ProfileUtils.getAvatarURLOrUndefined(jury)}
                        fullName={ProfileUtils.getFullNameString(jury)}
                        text={Lang(jury?.about, language) || ''}
                        id={jury?.designerId}
                        onClick={handleOpenProfileClick}
                        isCGRave
                        hasContext={!!jury?.context}
                    />
                )) 
                }
            </JuryCardsWrapper>
            }
        </Outer>
        )
    }

    return (
        <Outer style={{ marginTop: '64px', marginBottom: '104px' }}>
            <PopUpMenu
                key="menu-popup-deziiign"
                isVisible={visiblePopUp}
                onClose={() => setIsVisiblePopUp(false)}
                activeTab={selectedTab}
                showOnlyTabs
            />

            <SmthTitle isMobile={isMobile}>
                <TitleText isMobile={isMobile}>{competition?.name}</TitleText>
            </SmthTitle>

            <JuryHeader isMobile={isMobile}>
                <ResizedImage files={competition?.titleImages} />
            </JuryHeader>

            {(descriptionText && descriptionText !== '') && (
                <JuryContent isMobile={isMobile}>
                    <CompetitionJuryCardText 
                        isMobile={isMobile}
                        fontSize={"20"} 
                        color="#151514" 
                        fw={"400"}
                        halfBlock={"504"}
                        lh={"32"}
                        ls={"-0.02"}>
                        {decodedString(descriptionText)}
                    </CompetitionJuryCardText>
                </JuryContent>
            )}

            <JuryCardsWrapper pt={"24"} isMobile={isMobile}>
                {translatedJuryList.length && translatedJuryList.map((jury: any) => (
                    <CompetitionJuryCard 
                        key={jury?.designerId}
                        avatar={ProfileUtils.getAvatarURLOrUndefined(jury)}
                        fullName={ProfileUtils.getFullNameString(jury)}
                        text={Lang(jury?.about, language) || ''}
                        id={jury?.designerId}
                        onClick={handleOpenProfileClick}
                        hasContext={!!jury?.context}
                    />
                )) 
                }
            </JuryCardsWrapper>
        </Outer>
    )
}
import { 
    Competition, 
    CompetitionAPI, 
    DesignerAPI, 
    Designer,
    API,
    Lang,
} from "@brg/api";
import { ProfileUtils } from 'core/auth';
import { useToasts, useIsMobile, ResizedImage } from "@brg/ui";
import { useHistory } from "react-router-dom";
import {FC, useState, useEffect, useMemo} from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { 
    JuryHeader, 
    JuryContent, 
    JuryCardsWrapper 
} from "./styles";
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { CompetitionJuryCard } from "../CreateCompetitionPage/CompetitionJury/CompetitionJuryCard";
import { CompetitionJuryCardText } from "../CreateCompetitionPage/styles";
import { CreateLinkTo } from "shared/constants/linkTo";
import { SmthTitle, TitleText } from "shared/pages/opencallsPage/GetCompetitionItem/style";
import { Outer } from "shared/pages/explore/styles";
import nameUtils from "core/helpers/nameUtils";
import { AppTester } from "supporting";
import { LoaderSpinner } from "shared/modals/artzLegalsModal/LoaderAnimation";

interface IJuryProps {
    classname?: any;
    openLikeTab?: boolean;
    externalId?: string;
}

export const CompetitionJuryPage: FC <IJuryProps> = ({ openLikeTab, externalId }) => {

    /**
     * Парсер для отображение спецсимволов html 
     */
    const parser = new DOMParser();
    const decodedString = (str: string | undefined) => {
        return parser.parseFromString(`<!doctype html><body>${str}`, 'text/html').body.textContent;
    }

    const { id = externalId } = useParams<{ id: string }>();

    const history = useHistory();
    const isCGRave = AppTester.isCGRAVE();
    const { i18n: { language } } = useTranslation();
    const isMobile = useIsMobile();
    const [competition, setCompetition] = useState<Competition<'Local'>>();
    const [descriptionText, setDescriptionText] = useState<string>();
    const [juryList, setJuryList] = useState<Designer<'Global'>[]>([]);
    const translatedJuryList = useMemo(() => API.toLang<Designer<'Local'>[]>(juryList, language), [juryList, language])

    const [selectedTab, setSelectedTab] = useState('jury');
    const [visiblePopUp, setIsVisiblePopUp] = useState<boolean>(false);

    useEffect(() => {
        if (id) {
            CompetitionAPI.Get({ idCompetition: id})
            .then((r: any) => r.json())
            .then((v: any) => API.toLang<Competition<'Local'>>(v, language))
            .then((d: any) => setCompetition(d))
        }
    }, [id])

    const handleOpenProfileClick = (id: string) => {
        return history.push(CreateLinkTo.designer(id))
    }
    useEffect(() => {
        if (competition && competition?.juryID) {
            DesignerAPI.GetList({ designerIds: competition?.juryID || [] })
              .then((v: any) => v.json())
              //@ts-ignore
              .then((v) => setJuryList(v.data));

        }
        if (competition && competition?.competitionInfo?.juryText) {
            setDescriptionText(Lang(competition?.competitionInfo?.juryText, language));
        }
    }, [competition])

    if (openLikeTab) {
        return (
            <JuryCardsWrapper pt={"0"} isMobile={isMobile}>
                {!!translatedJuryList.length && translatedJuryList.map((jury: any) => (
                    <CompetitionJuryCard 
                        key={jury?.designerId}
                        avatar={ProfileUtils.getAvatarURLOrUndefined(jury)}
                        //@ts-ignore
                        fullName={nameUtils.getFullNameString(jury)}
                        text={Lang(jury?.about, language) || ''}
                        id={jury?.designerId}
                        onClick={handleOpenProfileClick}
                        hasContext={!!jury?.context}
                    />
                )) 
                }
            </JuryCardsWrapper>
        )
    }
    if(isCGRave){
        return (
            <Outer style={{ marginBottom: '64px' }}>
            {!translatedJuryList.length ? <LoaderSpinner color={'#909090'}/> 
            : <JuryCardsWrapper pt={"24"} isMobile={isMobile}>
                {translatedJuryList.length && translatedJuryList.map((jury: any) => (
                    <CompetitionJuryCard 
                        key={jury?.designerId}
                        avatar={ProfileUtils.getAvatarURLOrUndefined(jury)}
                        fullName={ProfileUtils.getFullNameString(jury)}
                        text={Lang(jury?.about, language) || ''}
                        id={jury?.designerId}
                        onClick={handleOpenProfileClick}
                        isCGRave
                        hasContext={!!jury?.context}
                    />
                )) 
                }
            </JuryCardsWrapper>
            }
        </Outer>
        )
    }

    return (
        <Outer style={{ marginTop: '64px', marginBottom: '104px' }}>
            <PopUpMenu
                key="menu-popup-deziiign"
                isVisible={visiblePopUp}
                onClose={() => setIsVisiblePopUp(false)}
                activeTab={selectedTab}
                showOnlyTabs
            />

            <SmthTitle isMobile={isMobile}>
                <TitleText isMobile={isMobile}>{competition?.name}</TitleText>
            </SmthTitle>

            <JuryHeader isMobile={isMobile}>
                <ResizedImage files={competition?.titleImages} />
            </JuryHeader>

            {(descriptionText && descriptionText !== '') && (
                <JuryContent isMobile={isMobile}>
                    <CompetitionJuryCardText 
                        isMobile={isMobile}
                        fontSize={"20"} 
                        color="#151514" 
                        fw={"400"}
                        halfBlock={"504"}
                        lh={"32"}
                        ls={"-0.02"}>
                        {decodedString(descriptionText)}
                    </CompetitionJuryCardText>
                </JuryContent>
            )}

            <JuryCardsWrapper pt={"24"} isMobile={isMobile}>
                {translatedJuryList.length && translatedJuryList.map((jury: any) => (
                    <CompetitionJuryCard 
                        key={jury?.designerId}
                        avatar={ProfileUtils.getAvatarURLOrUndefined(jury)}
                        fullName={ProfileUtils.getFullNameString(jury)}
                        text={Lang(jury?.about, language) || ''}
                        id={jury?.designerId}
                        onClick={handleOpenProfileClick}
                        hasContext={!!jury?.context}
                    />
                )) 
                }
            </JuryCardsWrapper>
        </Outer>
    )
}
